import { DirectionsService } from "~/entity/Directions/api/service";

export const useDirections = () => {
  const directionsGet = DirectionsService.GET.getDirections;
  const directionsCreate = DirectionsService.POST.createDirections;
  const directionsPut = DirectionsService.PUT.putDirections;
  const deleteDitection = DirectionsService.DELETE.deleteDitection;

  return {
    directionsGet,
    directionsCreate,
    directionsPut,
    deleteDitection
  };
};
